"use strict";

/**
 * @namespace
 */
gc.gis.style = gc.gis.style || {};

/**
 * @classdesc
 * Abstrakte Wrapperklasse für Styles.
 *
 * @class
 * @abstract
 * @extends gc.gis.GCWrappable
 * @memberof gc.gis.style
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.style.GCAbstractStyle = function()
{
    gc.gis.GCWrappable.call(this);
};
gc.gis.style.GCAbstractStyle.prototype = Object.create(gc.gis.GCWrappable.prototype);